import {ColumnDef} from '@tanstack/react-table'
import TimezoneAwareTimestamp from '../../components/common/TimezoneAwareTimestamp'

import {HomeTableProps} from "./HomeTypes";
import {switchTransactionMethodType, switchTransactionStatusType} from "../../functions";

import BlockToken from "../../components/common/BlockToken";
import TableMobileText from "../../components/common/TableMobileText";
import WalletAddress from "../../components/common/WalletAddress";

export const HomeTableColumns = (
  isMobile?: boolean
): ColumnDef<HomeTableProps>[] => {
  return [
    {
      id: "method",
      accessorKey: 'method',
      enableSorting: true,
      header: () => <>Method</>,
      cell: ({row}) => {
        const { text, icon: IconComponent } = switchTransactionMethodType(row.original.method);
        return (
          <>
            <TableMobileText text="Method"/>

            <div className="c-inline-flex">
              <i>{IconComponent}</i>
              {text}
            </div>
          </>
        )
      }
    },
    {
      id: "stable_amount",
      accessorKey: 'stable_amount',
      enableSorting: true,
      header: () => <>Stablecoin & Amount</>,
      cell: ({row}) => {
        const currency = row.original.stablecoin_amount.currency
        return (
          <>
            <TableMobileText text="Stablecoin & Amount"/>
            <BlockToken
              token={currency}
              hasName
              hasNumberValue
              value={row.original.stablecoin_amount.amount}
              prefix="$"
              currencyContext="transaction"
              align="right"
              useMonospace={true}
            />
          </>
        )
      }
    },
    {
      id: "status",
      accessorKey: 'status',
      enableSorting: true,
      header: () => <>Status</>,
      cell: ({row}) => {
        return (
          <>
            <TableMobileText text="Status"/>
            {switchTransactionStatusType(row.original.status)}
          </>
        )
      }
    },
    {
      id: "transaction_id",
      accessorKey: 'transaction_id',
      enableSorting: true,
      header: () => <>Transaction Hash</>,
      cell: ({row}) => {
        const hash = row.original.transaction_id;
        const explorerLink = row.original.transaction_link;
        return (
          <>
            <TableMobileText text="Transaction Hash"/>
            {hash ? (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <a 
                  href={explorerLink} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{ textDecoration: 'none', color: 'inherit' }}
                >
                  <WalletAddress 
                    address={hash}
                    showCopyButton={false}
                    truncateLength={{ start: 6, end: 4 }}
                  />
                </a>
                <button 
                  onClick={async () => {
                    try {
                      await navigator.clipboard.writeText(hash);
                    } catch (err) {
                      console.error('Failed to copy hash:', err);
                    }
                  }}
                  style={{ 
                    background: 'none', 
                    border: 'none', 
                    cursor: 'pointer', 
                    padding: '4px',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                  title="Copy to clipboard"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2" stroke="currentColor" strokeWidth="2"/>
                    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                </button>
              </div>
            ) : (
              <span>—</span>
            )}
          </>
        )
      }
    },
    {
      id: "payout_amount",
      accessorKey: 'payout_amount',
      enableSorting: true,
      header: () => <>Payout Currency & Amount</>,
      cell: ({row}) => {
        const currency = row.original.payout_amount.currency
        return (
          <>
            <TableMobileText text="Payout Currency & Amount"/>
            <BlockToken
              token={currency}
              hasName
              hasNumberValue
              value={row.original.payout_amount.amount}
              prefix="$"
              currencyContext="transaction"
              align="right"
              useMonospace={true}
            />
          </>
        )
      }
    },
    {
      id: "date",
      accessorKey: 'date',
      enableSorting: true,
      header: () => <>Transaction date</>,
      cell: ({row}) => {
        return (
          <>
            <TableMobileText text="Transaction date"/>
            <TimezoneAwareTimestamp 
              dateString={row.original.date} 
              format="datetime"
            />
          </>
        )
      }
    },
  ]
}